
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".2","d":"M71.293 8.533H51.935V6.4c0-3.529-2.872-6.4-6.4-6.4h-17.07c-3.529 0-6.4 2.871-6.4 6.4v2.133H2.72a2.139 2.139 0 00-2.133 2.133V57.6c0 3.529 2.871 6.4 6.4 6.4h60.025c3.53 0 6.4-2.872 6.4-6.4V10.704c-.08-1.403-.943-2.162-2.119-2.17zM26.332 6.4c0-1.177.957-2.133 2.134-2.133h17.068c1.175 0 2.134.956 2.134 2.133v2.133H26.332V6.4zm41.987 6.4l-6.627 19.873a2.13 2.13 0 01-2.023 1.46H47.668v-2.134a2.133 2.133 0 00-2.134-2.133H28.466a2.133 2.133 0 00-2.134 2.133v2.134H14.331a2.13 2.13 0 01-2.024-1.46L5.681 12.8h62.638zM43.401 34.133v4.266H30.599v-4.266h12.802zm25.745 23.466a2.137 2.137 0 01-2.134 2.133H6.988a2.136 2.136 0 01-2.134-2.133V23.81L8.26 34.022A6.39 6.39 0 0014.33 38.4h12.001v2.133c0 1.18.955 2.134 2.134 2.134h17.068a2.133 2.133 0 002.134-2.134V38.4h12.001a6.391 6.391 0 006.072-4.377l3.405-10.211v33.788z","fill":"#8F7A61"}})])
          )
        }
      }
    